import React from 'react';
import { ScreenProps } from '@fnol/library/src/lib';
import { Button } from '@fnol/library/src/components';
import Box from '@mui/material/Box';
import { translations } from '../../lib/consts';
import { Typography } from '@mui/material';
import { common } from '@fnol/library/src/lib/consts';

export const SecondMessage = ({ navigator }: ScreenProps) => {
    const [currentStep, { goForward, goBack }] = navigator;
    return (
        <>
            <Box sx={{ width: '100%', paddingTop: '15px' }}>
                <Typography>
                    <div style={{ textAlign: 'center' }}>
                        <h2>{translations.INTRO_MESSAGE_2_TITLE}</h2>
                    </div>
                    <p style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>{translations.INTRO_MESSAGE_2_SUBTITLE_1}</p>
                    <p style={{ fontSize: '1.1rem' }}>{translations.INTRO_MESSAGE_2_LINE_1}</p>
                    <p style={{ fontSize: '1.1rem' }}>{translations.INTRO_MESSAGE_2_LINE_10}</p>
                    <p style={{ textDecoration: 'underline', fontSize: '1.1rem' }}>
                        {translations.INTRO_MESSAGE_2_LINE_2}
                    </p>
                    <ul style={{ fontSize: '1.1rem' }}>
                        <li>{translations.INTRO_MESSAGE_2_LINE_3}</li>
                        <li>{translations.INTRO_MESSAGE_2_LINE_4}</li>
                        <li>{translations.INTRO_MESSAGE_2_LINE_5}</li>
                    </ul>
                    <p style={{ fontSize: '1.1rem' }}>{translations.INTRO_MESSAGE_2_LINE_6}</p>
                    <p style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>{translations.INTRO_MESSAGE_2_SUBTITLE_2}</p>
                    <ul style={{ fontSize: '1.1rem' }}>
                        <li>{translations.INTRO_MESSAGE_2_LINE_7}</li>
                    </ul>
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', paddingTop: '15px' }}>
                <Button onClickHandler={goBack} label={common.PREVIOUS} />
                <Button onClickHandler={goForward} label={common.NEXT} />
            </Box>
        </>
    );
};
